import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
// import { profileRequest } from '../../service/actions/userActions'
import { getProfile } from '../../service/actions/profileActions'
import jwt_decode from "jwt-decode";
import { useSelector } from 'react-redux'


const PrivateRoute = ({ getProfileAction }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true)
  const signedInUser = useSelector(state => state.userReducer.signedInUser)

  useEffect(() => {
    // const accessToken = localStorage.getItem("accessToken")

    if (signedInUser?.accessToken) {
      const decodedToken = jwt_decode(signedInUser?.accessToken)
      if (parseInt(decodedToken.exp) * 1000 > Date.now()) {
        setIsAuthenticated(true)
      } else {
        setIsAuthenticated(false)
        // window.location = "/login"
      }
    } else {
      // window.location = "/login"

      setIsAuthenticated(false)

    }
  }, [])

  // useEffect(() => {
  //   if (notAccessed) {
  //     localStorage.removeItem('currentUser')
  //     window.location.reload()
  //   }
  // }, [notAccessed])
  if (isAuthenticated || !signedInUser) {
    return <Outlet />
  } else {
    window.location = "/login"
  }

  // return isAuthenticated ? 
  //   // true
  //   <Outlet />
  // : 
  //   <Navigate to="/login" />

}
PrivateRoute.propTypes = {
  // getProfile: PropTypes.func,
  notAccessed: PropTypes.bool,
}
const mapStateToProps = (state) => ({
  notAccessed: state.userReducer.error,
})

const mapDispatchToProps = (dispatch) => ({
  getProfileAction: () => dispatch(getProfile()),
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
